module.exports = __webpack_public_path__ + "img/Payment_success_illustration.7cfc107c.svg";